<template>
	<div class="component-index">
		<FunctionTitle :title="mainTitle" />
		<CommonFlame :title="title">
			<template v-if="!$vuetify.breakpoint.xs" v-slot:app-bar-btn>
				<v-btn v-if="authority" color="primary" class="ml-2" @click="$router.push({ path: '/components/new' })">
					<v-icon class="mr-1">mdi-plus</v-icon>
					部品追加
				</v-btn>
				<v-menu ref="menu" offset-y :close-on-content-click="false">
					<template v-slot:activator="{ on, attrs }">
						<v-btn color="primary" dark v-bind="attrs" v-on="on"> <v-icon class="mr-2">mdi-magnify</v-icon>検索 </v-btn>
					</template>
					<v-card width="300px">
						<v-app-bar dense color="primary" flat>
							<v-app-bar-title class="color-white text-body-1 font-weight-bold">絞り込み検索</v-app-bar-title>
						</v-app-bar>
						<v-card-text class="pa-2">
							<v-form ref="form">
								<v-text-field v-model.trim="q.name_cont" label="部品名" hint="部品名を入力してください" class="mt-4" outlined dense></v-text-field>

								<v-text-field v-model.trim="q.part_number_cont" label="品番" hint="品番を入力してください" class="mt-4" outlined dense></v-text-field>

								<v-row class="mt-4" no-gutters justify="center">
									<v-btn color="secondary"  @click.prevent="search(1)" class="mr-2">
										<v-icon class="mr-2">mdi-magnify</v-icon>
										検索する</v-btn
									>
									<v-btn color="secondary" outlined @click="resetForm"> クリア</v-btn>
								</v-row>
							</v-form>
						</v-card-text>
					</v-card>
				</v-menu>
			</template>

			<template v-if="$vuetify.breakpoint.xs">
				<v-btn v-if="authority" color="secondary" class="ml-2" @click="$router.push({ path: '/components/new' })">
					<v-icon class="mr-1">mdi-plus</v-icon>
					部品追加
				</v-btn>
				<v-divider class="mt-1"></v-divider>
				<v-row no-gutters :class="$vuetify.breakpoint.xs ? 'mt-2' : ''">
					<h3 class="text-h6 font-weight-bold">絞り込み検索</h3>
					<v-spacer />
					<v-switch
						color="primary"
						class="mt-0"
						v-model="showSearchForm"
						:label="showSearchForm ? 'フォームを隠す' : 'フォームを表示'"
						hide-details
					/>
				</v-row>
				<template>
					<v-sheet v-if="showSearchForm" elevation="0">
						<v-form ref="form">
							<v-text-field
								v-model.trim="q.name_cont"
								label="部品名"
								hint="部品名を入力してください"
								class="mt-2"
								outlined
								dense
								hide-details
							></v-text-field>

							<v-text-field
								v-model.trim="q.part_number_cont"
								label="品番"
								hint="品番を入力してください"
								class="mt-2"
								outlined
								dense
								hide-details
							></v-text-field>

							<v-row class="my-4" no-gutters justify="center">
								<v-btn @click.prevent="search(1)" class="mr-2" color="secondary" outlined>
									<v-icon class="mr-2">mdi-magnify</v-icon>
									検索する</v-btn
								>
								<v-btn color="secondary" outlined @click="resetForm"> クリア</v-btn>
							</v-row>
						</v-form>
					</v-sheet>
				</template>
			</template>

			<div class="table-container px-2">
				<v-data-table
					locale="ja-JP"
					:headers="headers"
					:items="components"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
					@click:row="openDialog"
				>
					<!-- <template v-slot:[`item.id`]="{ item }">
						<router-link
							class="link"
							:to="{
								name: 'component_show',
								params: { id: item.id },
							}"
							><v-icon class="mr-1">mdi-file-document</v-icon>詳細</router-link
						>
					</template> -->
				</v-data-table>
				<PaginationModule :pagination="pagination" @get-page="getPage($event)"></PaginationModule>
			</div>
		</CommonFlame>
		<ComponentShowDialog 
		:authority="authority"
		:id="selectedId"
		:dialog.sync="componentShowDialog"
		/>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import Qs from "qs"
import PaginationModule from "../../modules/PaginationModule.vue"

import CommonFlame from "../shared/CommonFlame.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import ComponentShowDialog from "./components/ComponentShowDialog.vue"

export default {
	components: {
		CommonFlame,
		FunctionTitle,
		PaginationModule,
		ComponentShowDialog
	},
	data() {
		return {
			mainTitle: "部品",
			title: "部品一覧",
			components: [],
			component: "",
			authority: false,
			showSearchForm: true,
			selectedId: null,
			componentShowDialog: false,
			q: {
				name_cont: "",
				part_number_cont: "",
			},
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			headers: [
				{ text: "部品名", width: "150px", value: "name" },
				{ text: "品番", width: "150px", value: "part_number" },
				{ text: "現在庫", width: "150px", value: "stock" },
				{ text: "単価", width: "150px", value: "unit_price" },
				// { text: "", width: "150px", value: "id" },
			],
		}
	},
	mounted() {
		this.search(1)
	},
	methods: {
		openDialog(item) {
			this.selectedId = item.id
			this.componentShowDialog = true
		},
		search(page) {
			const headers = authenticate.setHeader()
			const params = { q: this.q, page }
			const paramsSerializer = (params) => Qs.stringify(params, { arrayFormat: "brackets" })
			axios
				.get(`/erp/v1/components`, { params, paramsSerializer, headers })
				.then((res) => {
					this.authority = res.data.create_flg
					this.components = res.data.components
					this.pagination = res.data.pagination
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				}).finally(() => {
					this.$refs.menu.isActive = false
				})
		},
		getPage(page) {
			this.search(page)
		},
		resetForm() {
			this.$refs.form.reset()
		},
	},
}
</script>
